import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';
import ButtonComponent from './forms/Button/ButtonComponent';

const AUTO_DISMISS_MS = 15000;

export default class ErrorsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { dataState: { errors: {}, isVisible: false } };
  }

  setErrors(errors) {
    if (!errors || (Array.isArray(errors) && errors.length === 0)) {
      return;
    }

    this.setState({
      dataState: {
        errors,
        isVisible: true,
      },
    });
  }

  setVisibility(isVisible) {
    this.setState((prevState) => ({
      dataState: {
        ...prevState.dataState,
        isVisible,
      },
    }));
  }

  render() {
    const { dataState } = this.state;
    return <Errors dataState={dataState} onClose={() => this.setVisibility(false)} />;
  }
}

function Errors({ dataState, onClose }) {
  useEffect(() => {
    let timeOut;
    if (dataState.isVisible) {
      timeOut = setTimeout(() => {
        onClose();
      }, AUTO_DISMISS_MS);
    }
    return () => clearTimeout(timeOut);
  }, [dataState.isVisible, onClose]);

  return (
    <>
      {dataState.isVisible && dataState.errors.length > 0 && (
        <StyledErrorContainer>
          <StyledCloseButton onClick={onClose} title="&times;" />
          <StyledError>
            <span className="error__text">
              {dataState.errors.length > 0 &&
                dataState.errors.map((error) => (
                  <div key={uuid()}>{error.key ? `${error.key}: ${error.data}` : error.data}</div>
                ))}
            </span>
          </StyledError>
        </StyledErrorContainer>
      )}
    </>
  );
}

Errors.propTypes = {
  dataState: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

const StyledErrorContainer = styled.div`
  background-color: #303030;
  position: fixed;
  left: 20px;
  bottom: 40px;
  padding: 22px 30px;
  padding-right: 50px;
  border-radius: 5px;
  color: #fff;
  max-width: 500px;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
`;

const StyledCloseButton = styled(ButtonComponent)`
  position: absolute;
  right: 8px;
  top: 8px;
  background: none;
  border: none;
  color: #fff;
  font-size: 1.4em;
  cursor: pointer;
  padding: 0 6px;
  line-height: 1;
`;

const StyledError = styled.div`
  font-size: 14px;
  line-height: 1.5;
`;
